import React, { /* useEffect, */ useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, FormikProps, FormikValues, useFormikContext } from 'formik';
import * as yup from 'yup';

import AppBar from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import Field from 'components/Field';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { NationalityCountry } from 'models/country';
import ResponseScreen, { BackgroundTypes } from 'screens/components/ResponseScreen';
/* import { extractErrorMessage } from 'utils/generic'; */
import { Container, Form, Fields } from './styles';
import useUserAccount from 'hooks/useUserAccount';
import ToggleCard from 'components/ToggleCard';
import { CreateResellerModel } from 'models/createResellerForm';
/* import { saveResellerCompany } from 'services/createResellerService'; */
import { useDispatch } from 'react-redux';
import { MyThunkDispatch } from 'store';
import { FaCopy } from 'react-icons/fa';
import Button from 'components/Buttons/Button';
import { saveResellerCompany } from 'services/createResellerService';
interface Props {
  loading: boolean;
  submitting: boolean;
  onConfirm: (createResaller: CreateResellerModel) => Promise<void>;
  onCloseFormCostCenter?: () => void;
  fetchCountryList: () => Promise<void>;
  nationalityCountries: NationalityCountry[];
  loadingNationalityCountries: boolean;
}

const CreateResellerForm = ({
  loading,
  submitting,
  onConfirm,
  onCloseFormCostCenter,
  fetchCountryList,
  nationalityCountries,
  loadingNationalityCountries,
}: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();
  const toast = useToast();
  const formikRef = useRef<FormikProps<CreateResellerModel>>(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const user = useUserAccount();
  const dispatch: MyThunkDispatch = useDispatch();
  const [username, setUserName] = useState<string>('user123');
  const [password, setPassword] = useState<string>('pass123');
  const [url, setUrl] = useState<string>('https://example.com');
  const [showResponse, setShowResponse] = useState<boolean>(false);

  const containsSequentialNumbers = (str: string): boolean => {
    for (let i = 0; i < str.length - 1; i++) {
      const current = parseInt(str[i]);
      const next = parseInt(str[i + 1]);

      if (!isNaN(current) && !isNaN(next)) {
        if (next === current + 1 || next === current - 1) {
          return true;
        }
      }
    }
    return false;
  };

  const validationSchema = yup.object().shape({
    userservice: yup.string().required(),
    apiBaseUrl: yup.string().required(),
    companyName: yup.string().required(),
    companyPhone: yup.string().required(),
    companyDocument: yup.string().required(),
    companyEmail: yup.string().required(),
    companyCountryId: yup.string().required(),
    companyCurrencyCode: yup.string().required(),
    companyBranchCode: yup.string().required(),
    companyProfileDocumentId: yup.number().required(),
    profileDocumentNumber: yup.number().required(),
    profilePassportDocumentNumber: yup.number().required(),
    userAdminFirstName: yup.string().required(),
    userAdminLastName: yup.string().required(),
    userAdminEmail: yup.string().required(),
    userAdminPhone: yup.string().required(),
    userAdminDocument: yup.string().required(),
    username: yup.string().trim().max(100).required(),
    password: yup
    .string()
    .test('password-validation', 'Senha inválida', function (value) {
          
      const password = value || '';
      const hasLength = password.length >= 8 && password.length <= 12;
      const hasSpecialChar = /[!¡”#$%/,*.@&()\-_=+{}\[\]|':;¿?<>\^]/.test(password);
      const hasUpperLower = /[a-z]/.test(password) && /[A-Z]/.test(password);
      const hasNumber = /\d/.test(password);
      const hasNoConsecutive = !/(\d)\1{1,}/.test(password);
      const hasNoSequentialNumbers = !containsSequentialNumbers(password);
      const hasUserInfo = validatePasswordContainsUserInfo(password);
          
      return hasLength && hasSpecialChar && hasUpperLower && hasNumber && hasNoConsecutive && hasNoSequentialNumbers && hasUserInfo;
    }),
    operatorNetacticaUsername: yup.string().required(),
    operatorNetacticaPassword: yup.string().required(),
    companyLineOfCreditPayment: yup.boolean().required(),
  });

  const initialValues: CreateResellerModel = {
    apiBaseUrl: '',
    userservice: '',
    companyName: '',
    companyDocument: '',
    companyEmail: '',
    companyCountryId: '',
    companyCurrencyCode: '',
    companyBranchCode: '',
    companyPhone: '',
    companyProfileDocumentId: 0,
    profileDocumentNumber: 0,
    profilePassportDocumentNumber: 0,
    userAdminFirstName: '',
    userAdminLastName: '',
    userAdminEmail: '',
    userAdminPhone: '',
    userAdminDocument: '',
    operatorNetacticaUsername: '',
    operatorNetacticaPassword: '',
    companyLineOfCreditPayment: true,
  };

  const handleConfirm = async (values: CreateResellerModel) => {
    (dispatch(saveResellerCompany(values)))
    .then((result) => {
      if (result === undefined)
      {
        throw new Error('Error al crear el Reseller');
      }
      setShowResponse(true);
      setUserName(result.supportImplementatorUsername);
      setPassword(result.supportImplementatorPassword);
      setUrl(`${result.apiBaseUrl}/corporate/login`);
    })
    .catch((error) => {
      console.error('Error:', error);
      toast.add({
        type: 'danger',
        message: error.message,
      });

    });
/*     try {
      const result = await dispatch(saveResellerCompany(values));
      if(result.data){
        setShowResponse(true);
        setUserName(result.supportImplementatorUsername);
        setPassword(result.supportImplementatorPassword);
        setUrl(`${result.apiBaseUrl}/corporate/login`);
      }
    } catch (error) {
      alert(t('createResellerForm.others.copyError') + error);
    } */
    



    console.log('aqui', values);
    /*     try {
      await onConfirm(values);
      setShowSuccess(true);
    } catch (error) {
      if (error.message) {
        if (error?.message?.includes('already') !== -1) {
          toast.add({
            type: 'danger',
            message: t('branchCompany.errors.alreadyExists'),
          });
        }
      } else {
        //alert(error.message);
        toast.add({
          type: 'danger',
          message: extractErrorMessage(error) || t('defaultError.default'),
        });
      }
    } */
  };

  const returnLoginPage = () => {
    history.replace('/corporate/login');
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert(t('createResellerForm.others.copySuccess'));
      })
      .catch((error) => {
        console.error(t('createResellerForm.others.copyError'), error);
      });
  };

  const copyAllToClipboard = () => {
    const textToCopy = `username: ${username}\npassword: ${password}\nurl: ${url}`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        alert(t('createResellerForm.others.copySuccess'));
      })
      .catch((err) => {
        console.error(t('createResellerForm.others.copyError'), err);
      });
  };

  const validatePassword = (password: string) => {
    const specialChars = /[!¡”#$%/,*.@&()\-_=+{}\[\]|':;¿?<>\^`]/;
  
    const isEmpty = password.trim().length === 0;
  
    const validations = [
      {
        name: 'length',
        title: t('userForm.accessSystem.length.title'),
        message: t('userForm.accessSystem.length.message'),
        valid: isEmpty ? false : password.length >= 8 && password.length <= 12
      },
      {
        name: 'special-char',
        title: t('userForm.accessSystem.specialChar.title'),
        message: t('userForm.accessSystem.specialChar.message'),
        valid: isEmpty ? false : specialChars.test(password)
      },
      {
        name: 'uppercase-char',
        title: t('userForm.accessSystem.uppercaseChar.title'),
        message: t('userForm.accessSystem.uppercaseChar.message'),
        valid: isEmpty ? false : /[a-z]/.test(password) && /[A-Z]/.test(password)
      },
      {
        name: 'numeric-char',
        title: t('userForm.accessSystem.numericChar.title'),
        message: t('userForm.accessSystem.numericChar.message'),
        valid: isEmpty ? false : /\d/.test(password)
      },
      {
        name: 'consecutive-char',
        title: t('userForm.accessSystem.consecutiveChar.title'),
        message: t('userForm.accessSystem.consecutiveChar.message'),
        valid: isEmpty ? false : (!/(\d)\1{1,}/.test(password) && !containsSequentialNumbers(password))
      },
      {
        name: 'profile-date',
        title: t('userForm.accessSystem.profileData.title'),
        message: t('userForm.accessSystem.profileData.message'),
        valid: isEmpty ? false : validatePasswordContainsUserInfo(password)
      }
    ];
  
    return validations;
  };

  const validatePasswordContainsUserInfo = (
    password: string
  ) => {
    
    if (!password) return false;

    // Lista de campos para validar
    const userValues = [
      formikRef.current?.values?.userAdminFirstName,
      formikRef.current?.values?.userAdminLastName,
      formikRef.current?.values?.userAdminDocument,
      formikRef.current?.values?.userAdminPhone,
      formikRef.current?.values?.userAdminEmail
    ].filter(Boolean); // Remove null/undefined

    const validation = userValues.some((val) => 
      password.sanitize().toLocaleLowerCase().includes(val.sanitize().toLocaleLowerCase())
    );

    return !validation;
  };

  const PasswordValidation = () => {
    const { values } = useFormikContext<{ password: string }>();
    const [rules, setRules] = useState(() => validatePassword(''));
  
    useEffect(() => {
      setRules(validatePassword(values.password || ''));
    }, [values.password]);
  
    return (
      <div style={{ marginTop: 8 }}>
        {values.password && rules.map(rule => (
          <div key={rule.name} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {rule.valid ? (
              <span style={{ color: 'green' }}>✔</span>
            ) : (
              <span style={{ color: 'red' }}>✖</span>
            )}
            <span style={{ fontSize: '12px', paddingTop: '3px' }}><b>{rule.title}: </b>{rule.message}</span>
          </div>
        ))}
      </div>
    );
  };
  
  return (
    <Container isFormOut>
      <Mobile>
        <AppBar>
          <h5>{t('createResellerForm.title')}</h5>
        </AppBar>
      </Mobile>
      {loading || loadingNationalityCountries ? (
        <Loader fullScreen />
      ) : (
        <>
          <Desktop>
            <ScreenHeader title={t('createResellerForm.title')} subtitle={t('createResellerForm.subtitle')} />
          </Desktop>
          {showResponse ? (
            <div style={{ width: 'fit-content' }}>
              <div
                style={{
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  width: 'fit-content',
                }}
              >
                <label style={{ marginRight: '10px', width: '100px', textAlign: 'right' }}>UserName:</label>
                <Input value={username} readOnly style={{ paddingRight: '40px' }} />
                <button
                  onClick={() => copyToClipboard(username)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    position: 'absolute',
                    right: '10px',
                  }}
                  title="Copiar"
                >
                  <FaCopy size={20} />
                </button>
              </div>

              <div
                style={{
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  width: 'fit-content',
                }}
              >
                <label style={{ marginRight: '10px', width: '100px', textAlign: 'right' }}>Password:</label>
                <Input value={password} readOnly style={{ paddingRight: '40px' }} />
                <button
                  onClick={() => copyToClipboard(password)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    position: 'absolute',
                    right: '10px',
                  }}
                  title="Copiar"
                >
                  <FaCopy size={20} />
                </button>
              </div>

              <div
                style={{
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  width: 'fit-content',
                }}
              >
                <label style={{ marginRight: '10px', width: '100px', textAlign: 'right' }}>URL:</label>
                <Input value={url} readOnly style={{ paddingRight: '40px' }} />
                <button
                  onClick={() => copyToClipboard(url)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    position: 'absolute',
                    right: '10px',
                  }}
                  title="Copiar"
                >
                  <FaCopy size={20} />
                </button>
              </div>
              <div style={{ display: 'flex', columnGap: '10px' }}>
                <Button
                  onClick={() => {
                    copyAllToClipboard();
                  }}
                  value={t('createResellerForm.others.copy')}
                />
                <Button
                  noBorder
                  customColor="#626e75"
                  onClick={() => {
                    returnLoginPage();
                  }}
                  value={t('createResellerForm.others.closeReturn')}
                />
              </div>
            </div>
          ) : (
            <Formik
              innerRef={formikRef}
              isInitialValid={(formik: any) => validationSchema.isValidSync(formik.initialValues)}
              initialValues={initialValues as CreateResellerModel}
              validationSchema={validationSchema}
              onSubmit={(values: CreateResellerModel) => handleConfirm(values)}
            >
              {({ values, dirty, isSubmitting, setFieldValue }: FormikValues) => (
                <>
                  <FormikSubmitErrorEffect />
                  <Form>
                    <Fields>
                      <Section title={t('createResellerForm.BasicInformation')}>
                        <Field name="userservice" label={t('createResellerForm.CompanyUserService')}>
                          <Input placeholder="userservice" />
                        </Field>
                        <Field name="apiBaseUrl" label={t('createResellerForm.CompanyURL')}>
                          <Input placeholder="apiBaseUrl" />
                        </Field>
                      </Section>
                      <Section title={t('createResellerForm.CompanyData')}>
                        <Field name="companyName" label={t('createResellerForm.CompanyName')}>
                          <Input placeholder="companyName" />
                        </Field>
                        <Field name="companyPhone" label={t('createResellerForm.CompanyPhoneNumber')}>
                          <Input placeholder="companyPhone" />
                        </Field>
                        <Field name="companyDocument" label={t('createResellerForm.CompanyDocumentNumber')}>
                          <Input placeholder="companyDocument" />
                        </Field>
                        <Field name="companyEmail" label={t('createResellerForm.CompanyEmail')}>
                          <Input placeholder="companyEmail" />
                        </Field>
                        <Field name="companyCountryId" label={t('createResellerForm.CompanyCountyCode')}>
                          <Input placeholder="companyCountryId" />
                        </Field>
                        <Field name="companyCurrencyCode" label={t('createResellerForm.CompanyCurrencyCode')}>
                          <Input placeholder="companyCurrencyCode" />
                        </Field>
                        <Field name="companyBranchCode" label={t('createResellerForm.CompanyBranchCode')}>
                          <Input placeholder="companyBranchCode" />
                        </Field>
                        <Field name="companyProfileDocumentId" label={t('createResellerForm.CompanyNetsuiteCode')}>
                          <Input placeholder="companyProfileDocumentId" />
                        </Field>
                        <Field name="profileDocumentNumber" label={t('createResellerForm.ProfileDocumentNetsuiteCode')}>
                          <Input placeholder="profileDocumentNumber" />
                        </Field>
                        <Field
                          name="profilePassportDocumentNumber"
                          label={t('createResellerForm.PassportDocumentNetsuiteCode')}
                        >
                          <Input placeholder="profilePassportDocumentNumber" />
                        </Field>
                      </Section>
                      <Section title={t('createResellerForm.AdminUser')}>
                        <Field name="userAdminFirstName" label={t('createResellerForm.FirstName')}>
                          <Input placeholder="userAdminFirstName" />
                        </Field>
                        <Field name="userAdminLastName" label={t('createResellerForm.LastName')}>
                          <Input placeholder="userAdminLastName" />
                        </Field>
                        <Field name="userAdminEmail" label={t('createResellerForm.Email')}>
                          <Input placeholder="userAdminEmail" />
                        </Field>
                        <Field name="userAdminPhone" label={t('createResellerForm.PhoneNumber')}>
                          <Input placeholder="userAdminPhone" />
                        </Field>
                        <Field name="userAdminDocument" label={t('createResellerForm.DocumentNumber')}>
                          <Input placeholder="userAdminDocument" />
                        </Field>
                      </Section>
                      <Section title={t('createResellerForm.NetsuiteOperatorData')}>
                        <Field name="operatorNetacticaUsername" label={t('createResellerForm.OperatorUsername')}>
                          <Input placeholder="operatorNetacticaUsername" />
                        </Field>
                        <Field name="operatorNetacticaPassword" label={t('createResellerForm.OperatorPassword')}>
                          <Input placeholder="operatorNetacticaPassword" />
                        </Field>
                      </Section>
                      <Section title={t('createResellerForm.PaymentInformation')}>
                        <ToggleCard
                          title={t('createResellerForm.CreditLine')}
                          value={values.companyLineOfCreditPayment}
                          onToggle={(_, value) => setFieldValue('companyLineOfCreditPayment', value ? true : false)}
                          hide={false}
                        />
                        <ToggleCard
                          title={t('createResellerForm.CreditCard')}
                          value={!values.companyLineOfCreditPayment}
                          onToggle={(_, value) => setFieldValue('companyLineOfCreditPayment', value ? false : true)}
                          hide={false}
                        />
                      </Section>
                    </Fields>

                    <Section>
                      <Button
                        noBorder
                        customColor="#626e75"
                        onClick={() => {
                          returnLoginPage();
                        }}
                        value={t('createResellerForm.others.cancelClose')}
                      />

                      <SubmitButton isEdit={false} dirty={dirty} loading={submitting || isSubmitting}>
                        {t('createResellerForm.CreateCompanyReseller')}
                      </SubmitButton>
                    </Section>
                  </Form>
                </>
              )}
            </Formik>
          )}

          <ResponseScreen
            show={showSuccess}
            background={BackgroundTypes.Mountain}
            text={t('branchCompany.form.successTitle')}
            subText={t('branchCompany.form.successConfirmText')}
            buttonOnClick={() => history.push('/corporate/billingCompanyList')}
            buttonText={t('branchCompany.form.successButtonText')}
          />
        </>
      )}
    </Container>
  );
};

export default CreateResellerForm;
